import React from "react";

const Mission = () => {
  return <div style={{ flex: 1 }}>Mission</div>;
};

export default Mission;
